import { render, staticRenderFns } from "./customerWithdrawal.vue?vue&type=template&id=3ff91bc4&"
import script from "./customerWithdrawal.vue?vue&type=script&lang=js&"
export * from "./customerWithdrawal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports